import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Loading } from '@/components/Loading'
import { LoadingFailedAlert } from '@/components/LoadingFailedAlert'
import { Step4Wrapper } from '@/containers/steps/travel/Step4/Step4Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { SelectedQuoteProvider } from '@/context/SelectedQuoteContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'

const Step4PageComponent = () => {
  const navigate = useNavigate()
  const {
    insuranceParamsId: paramsId,
    isLoadingData,
    insuranceParams,
    isContracted,
    error
  } = useInsuranceParams()

  const [showData, setShowData] = useState(!isLoadingData && insuranceParams)
  useEffect(() => {
    setShowData(!isLoadingData && insuranceParams)
  }, [!!insuranceParams, isLoadingData])

  useEffect(() => {
    if (isContracted) navigate(`/travel/steps/complete/${paramsId}`)
  }, [isContracted])

  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          {isLoadingData && <Loading large={true} />}
          {!isLoadingData && error && <LoadingFailedAlert />}
          {showData && (
            <MeetingRecordProvider insuranceParamsId={paramsId!}>
              <SelectedQuoteProvider>
                <SelectedOffersAddonProvider>
                  <Step4Wrapper />
                </SelectedOffersAddonProvider>
              </SelectedQuoteProvider>
            </MeetingRecordProvider>
          )}
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step4Page = WithAuth(Step4PageComponent)
